/**
 * This level logic is for the most part implemented by Konstantin
 */

import GameSceneImage from '../../Inamove/Components/GameSceneImage/GameSceneImage'
import { createInteractableObjectListener } from '../../Inamove/Components/InteractableObject'
import CinematicContainer from '../../Inamove/Containers/CinematicContainer/CinematicContainer'
import GameSceneContainer from '../../Inamove/Containers/GameSceneContainer/GameSceneContainer'
import InventoryContainer from '../../Inamove/Containers/InventoryContainer/InventoryContainer'
import LoadingContainer from '../../Inamove/Containers/LoadingContainer/LoadingContainer'
import AudioController from '../../Inamove/Controllers/AudioController'
import LevelController from '../../Inamove/Controllers/LevelController'
import Config from '../../Inamove/Containers/Config'
import { createTakeableObjectListener } from '../../Inamove/Components/TakeableObject'
import Video from '../../Inamove/Components/Video/Video'
import { spooky, playVideo } from '../../KUtil/help'
import LoadingController from '../../Inamove/Controllers/LoadingController'

const levelId = 'level13'

export default async function () {
    InventoryContainer.clean()
    CinematicContainer.hide()
    GameSceneContainer.hide()
    InventoryContainer.hide()
    LoadingController.reset()
    LoadingContainer.show()

    const level = await LevelController.loadLevel(levelId)

    const EndeAudio = AudioController.add(Config.LEVEL_PATH + 'level13/ende-geisterstadt' + Config.AUDIO_FILE_EXT)

    let ruckblendeIndex = 0
    const rueckblenden = new Array(6)
        .fill(1)
        .map((_, i) => new Video(Config.CINEMATIC_PATH + `Video${i + 1}` + Config.VIDEO_FILE_EXT))

    rueckblenden.forEach(LoadingController.addToQueue)

    //Zeichnungen laden
    const K257_Overlay = new GameSceneImage(Config.GAME_SCENE_PATH + 'K257/K257-overlay.png')
    const K260_Overlay = new GameSceneImage(Config.GAME_SCENE_PATH + 'K260/K260-overlay.png')
    const K279_Overlay = new GameSceneImage(Config.GAME_SCENE_PATH + 'K279/K279-overlay.png')
    const K293_Overlay = new GameSceneImage(Config.GAME_SCENE_PATH + 'K293/K293-overlay.png')
    const K305_Overlay = new GameSceneImage(Config.GAME_SCENE_PATH + 'K305/K305-overlay.png')
    const K320_Overlay = new GameSceneImage(Config.GAME_SCENE_PATH + 'K320/K320-overlay.png')
    ;[K257_Overlay, K260_Overlay, K279_Overlay, K293_Overlay, K305_Overlay, K320_Overlay].forEach(
        LoadingController.addToQueue
    )

    //Fototeile laden
    const K257_Fototeil = new GameSceneImage(Config.GAME_SCENE_PATH + 'K257/K257-fototeil.png')
    const K260_Fototeil = new GameSceneImage(Config.GAME_SCENE_PATH + 'K260/K260-fototeil.png')
    const K279_Fototeil = new GameSceneImage(Config.GAME_SCENE_PATH + 'K279/K279-fototeil.png')
    const K293_Fototeil = new GameSceneImage(Config.GAME_SCENE_PATH + 'K293/K293-fototeil.png')
    const K305_Fototeil = new GameSceneImage(Config.GAME_SCENE_PATH + 'K305/K305-fototeil.png')
    const K306_Fototeil = new GameSceneImage(Config.GAME_SCENE_PATH + 'K306/K306-fototeil.png')
    const K320_Fototeil = new GameSceneImage(Config.GAME_SCENE_PATH + 'K320/K320-fototeil.png')
    const K321_Fototeil = new GameSceneImage(Config.GAME_SCENE_PATH + 'K321/K321-fototeil.png')
    ;[
        K257_Fototeil,
        K260_Fototeil,
        K279_Fototeil,
        K293_Fototeil,
        K305_Fototeil,
        K306_Fototeil,
        K320_Fototeil,
        K321_Fototeil,
    ].forEach(LoadingController.addToQueue)

    //Fotoleuchten laden
    const K257_glow = new GameSceneImage(Config.GAME_SCENE_PATH + 'K257/K257-fototeil-1-leuchten.png')
    const K260_glow = new GameSceneImage(Config.GAME_SCENE_PATH + 'K260/K260-fototeil-2-leuchten.png')
    const K279_glow = new GameSceneImage(Config.GAME_SCENE_PATH + 'K279/K279-fototeil-3-leuchten.png')
    const K293_glow = new GameSceneImage(Config.GAME_SCENE_PATH + 'K293/K293-fototeil-4-leuchten.png')
    const K305_glow = new GameSceneImage(Config.GAME_SCENE_PATH + 'K305/K305-fototeil-5-leuchten.png')
    const K306_glow = new GameSceneImage(Config.GAME_SCENE_PATH + 'K306/K306-fototeil-5-leuchten.png')
    const K320_glow = new GameSceneImage(Config.GAME_SCENE_PATH + 'K320/K320-fototeil-6-leuchten.png')
    const K321_glow = new GameSceneImage(Config.GAME_SCENE_PATH + 'K321/K321-fototeil-6-leuchten.png')
    ;[K257_glow, K260_glow, K279_glow, K293_glow, K305_glow, K306_glow, K320_glow, K321_glow].forEach(
        LoadingController.addToQueue
    )
    const inventoryItemsFromFotos = ['I58', 'I59', 'I60', 'I61', 'I62', 'I63']
    InventoryContainer.loadItems(inventoryItemsFromFotos)

    //Fotoalbum
    const K323_Fotoalbum = new GameSceneImage(Config.GAME_SCENE_PATH + 'K323/K323-I46-fotoalbum.png')
    const K324_Fotoalbum = new GameSceneImage(Config.GAME_SCENE_PATH + 'K324/K324-I46-fotoalbum.png')
    ;[K323_Fotoalbum, K324_Fotoalbum].forEach(LoadingController.addToQueue)

    //glow style
    K257_glow.element.classList.add('glow')
    K260_glow.element.classList.add('glow')
    K279_glow.element.classList.add('glow')
    K293_glow.element.classList.add('glow')
    K305_glow.element.classList.add('glow')
    K306_glow.element.classList.add('glow')
    K320_glow.element.classList.add('glow')
    K321_glow.element.classList.add('glow')

    //Geisterhaft
    //vanishing style zu betroffenen Overlays hinzufügen
    K257_Overlay.element.classList.add('vanishing')
    K260_Overlay.element.classList.add('vanishing')
    K279_Overlay.element.classList.add('vanishing')
    K293_Overlay.element.classList.add('vanishing')
    K305_Overlay.element.classList.add('vanishing')
    K320_Overlay.element.classList.add('vanishing')
    //Ids der overlays
    const overlayImages = [
        'K257-overlay',
        'K260-overlay',
        'K279-overlay',
        'K293-overlay',
        'K305-overlay',
        'K320-overlay',
    ]
    const minDist = 0.2
    //Macht die overlayImages geisterhaft (siehe KUtil/help:spooky)
    spooky(overlayImages, minDist, 'vanishing', true)

    //show images
    level.gameScenes.K257.addImage(K257_Overlay)
    level.gameScenes.K260.addImage(K260_Overlay)
    level.gameScenes.K279.addImage(K279_Overlay)
    level.gameScenes.K293.addImage(K293_Overlay)
    level.gameScenes.K305.addImage(K305_Overlay)
    level.gameScenes.K320.addImage(K320_Overlay)

    //Fotoalbum
    level.gameScenes.K323.addImage(K323_Fotoalbum)
    createTakeableObjectListener('Fotos').finally(() => {
        level.gameScenes.K323.removeImage(K323_Fotoalbum, true)
    })

    //hide fototeile
    level.gameScenes.K257.hideInteractableObject('fototeil_K257')
    level.gameScenes.K260.hideInteractableObject('fototeil_K260')
    level.gameScenes.K279.hideInteractableObject('fototeil_K279')
    level.gameScenes.K293.hideInteractableObject('fototeil_K293')
    level.gameScenes.K306.hideInteractableObject('fototeil_K306')
    level.gameScenes.K321.hideInteractableObject('fototeil_K321')

    let gesammelteFototeile = 0
    function addFoto() {
        gesammelteFototeile++
        //Fügt das zur Anzahl der gesammelten Fototeile passende Item zum Inventar hinzu, entfernt die anderen
        switch (gesammelteFototeile) {
            case 1:
                InventoryContainer.addItems(['I58'])
                break
            case 2:
                InventoryContainer.removeItems(['I58'])
                InventoryContainer.addItems(['I59'])
                break
            case 3:
                InventoryContainer.removeItems(['I59'])
                InventoryContainer.addItems(['I60'])
                break
            case 4:
                InventoryContainer.removeItems(['I60'])
                InventoryContainer.addItems(['I61'])
                break
            case 5:
                InventoryContainer.removeItems(['I61'])
                InventoryContainer.addItems(['I62'])
                break
            case 6:
                InventoryContainer.removeItems(['I62'])
                InventoryContainer.addItems(['I63'])
                break
            default:
                break
        }
    }

    //create interactables
    createInteractableObjectListener(
        'K257-overlay',
        async () => {
            await playVideo(rueckblenden[ruckblendeIndex])
            ruckblendeIndex += 1

            //Fototeil anzeigen
            level.gameScenes.K257.addImage(K257_Fototeil)
            level.gameScenes.K257.addImage(K257_glow)
            level.gameScenes.K257.showInteractableObject('fototeil_K257')

            createInteractableObjectListener(
                'fototeil_K257',
                () => {
                    //aufsammelt erhöht Fototeil-Zähler um 1
                    addFoto()
                    //Nachdem das Fototeil aufgenommen wurde, verschwindet es vollständig
                    level.gameScenes.K257.hideInteractableObject('fototeil_K257')
                    level.gameScenes.K257.removeImage(K257_Fototeil)
                    level.gameScenes.K257.removeImage(K257_glow)
                },
                true
            )
        },
        true
    )

    createInteractableObjectListener(
        'K260-overlay',
        async () => {
            await playVideo(rueckblenden[ruckblendeIndex])
            ruckblendeIndex += 1

            //Fototeil anzeigen
            level.gameScenes.K260.addImage(K260_Fototeil)
            level.gameScenes.K260.addImage(K260_glow)
            level.gameScenes.K260.showInteractableObject('fototeil_K260')

            createInteractableObjectListener(
                'fototeil_K260',
                () => {
                    addFoto()
                    level.gameScenes.K260.hideInteractableObject('fototeil_K260')
                    level.gameScenes.K260.removeImage(K260_Fototeil)
                    level.gameScenes.K260.removeImage(K260_glow)
                },
                true
            )
        },
        true
    )

    createInteractableObjectListener(
        'K279-overlay',
        async () => {
            await playVideo(rueckblenden[ruckblendeIndex])
            ruckblendeIndex += 1

            //Fototeil anzeigen
            level.gameScenes.K279.addImage(K279_Fototeil)
            level.gameScenes.K279.addImage(K279_glow)
            level.gameScenes.K279.showInteractableObject('fototeil_K279')
            createInteractableObjectListener(
                'fototeil_K279',
                () => {
                    addFoto()
                    level.gameScenes.K279.hideInteractableObject('fototeil_K279')
                    level.gameScenes.K279.removeImage(K279_Fototeil)
                    level.gameScenes.K279.removeImage(K279_glow)
                },
                true
            )
        },
        true
    )

    createInteractableObjectListener(
        'K293-overlay',
        async () => {
            await playVideo(rueckblenden[ruckblendeIndex])
            ruckblendeIndex += 1
            //Fototeil anzeigen
            level.gameScenes.K293.addImage(K293_Fototeil)
            level.gameScenes.K293.addImage(K293_glow)
            level.gameScenes.K293.showInteractableObject('fototeil_K293')
            createInteractableObjectListener(
                'fototeil_K293',
                () => {
                    addFoto()
                    level.gameScenes.K293.hideInteractableObject('fototeil_K293')
                    level.gameScenes.K293.removeImage(K293_Fototeil)
                    level.gameScenes.K293.removeImage(K293_glow)
                },
                true
            )
        },
        true
    )

    createInteractableObjectListener(
        'K305-overlay',
        async () => {
            await playVideo(rueckblenden[ruckblendeIndex])
            ruckblendeIndex += 1

            //Fototeil anzeigen
            level.gameScenes.K306.addImage(K306_Fototeil)
            level.gameScenes.K306.addImage(K306_glow)
            level.gameScenes.K306.showInteractableObject('fototeil_K306')

            level.gameScenes.K305.addImage(K305_Fototeil)
            level.gameScenes.K305.addImage(K305_glow)

            createInteractableObjectListener(
                'fototeil_K306',
                () => {
                    addFoto()
                    level.gameScenes.K306.hideInteractableObject('fototeil_K306')
                    level.gameScenes.K306.removeImage(K306_Fototeil)
                    level.gameScenes.K306.removeImage(K306_glow)
                },
                true
            )
        },
        true
    )

    createInteractableObjectListener(
        'K320-overlay',
        async () => {
            await playVideo(rueckblenden[ruckblendeIndex])
            ruckblendeIndex += 1

            //Fototeil anzeigen
            level.gameScenes.K320.addImage(K320_Fototeil)
            level.gameScenes.K320.addImage(K320_glow)

            level.gameScenes.K321.addImage(K321_Fototeil)
            level.gameScenes.K321.addImage(K321_glow)

            level.gameScenes.K321.showInteractableObject('fototeil_K321')

            createInteractableObjectListener(
                'fototeil_K321',
                () => {
                    addFoto()
                    level.gameScenes.K321.hideInteractableObject('fototeil_K321')
                    level.gameScenes.K321.removeImage(K321_Fototeil)
                    level.gameScenes.K321.removeImage(K321_glow)

                    level.gameScenes.K320.removeImage(K320_Fototeil)
                    level.gameScenes.K320.removeImage(K320_glow)
                },
                true
            )
        },
        true
    )

    //ready check
    const ItemCheck = new Promise<void>((resolve) => {
        let I64 = false
        let I46 = false
        addEventListener('Inventory.added', async (event) => {
            // @ts-ignore
            if (event.detail.itemId === 'I64') {
                I64 = true
            }
            // @ts-ignore
            if (event.detail.itemId === 'I46') {
                I46 = true
            }
            if (I46 && I64) {
                level.soundtrackAudioId && AudioController.pause(level.soundtrackAudioId)
                await AudioController.play(EndeAudio)
                resolve()
            }
        })
    })

    await AudioController.addAllToLoadingQueue()
    await LoadingController.processQueue()
    await LoadingContainer.clickStart()

    LoadingContainer.hide()
    GameSceneContainer.show()

    LevelController.startLevel(levelId)

    return ItemCheck
}
